const numChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
const unitChar = ['', '十', '百', '千', '万', '十', '百', '千', '亿'];

function n2c(num) {
  if (typeof num !== 'number' || num < 0) {
    return num.toString();
  }
  
  if (num === 0) {
    return '零';
  }
  
  let str = num.toString();
  let result = '';
  let len = str.length;
  
  for (let i = 0; i < len; i++) {
    let n = parseInt(str[i]);
    let unitIndex = len - i - 1;
    
    if (n === 0) {
      if (result && result[result.length - 1] !== '零' && unitIndex % 4 !== 0) {
        result += '零';
      }
    } else {
      result += numChar[n] + unitChar[unitIndex];
    }
  }
  
  result = result.replace(/零+/g, '零');
  result = result.replace(/零亿/g, '亿');
  result = result.replace(/零万/g, '万');
  result = result.replace(/亿万/g, '亿');
  result = result.replace(/^一十/g, '十');
  
  return result;
}

export default n2c;



// WEBPACK FOOTER //
// ./src/common/numberToChinese.js